module.exports = __webpack_public_path__ + "static/media/linkedin-tile.37cacf03.svg";